function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.17188C1 3.07699 1.07693 3.00006 1.17182 3.00006H9.54808C9.70607 3.00006 9.78031 3.19534 9.66223 3.3003L8.92383 3.95666C8.89237 3.98462 8.85176 4.00006 8.80967 4.00006H1.17182C1.07693 4.00006 1 3.92313 1 3.82824V3.17188Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 7.00006,
  width: 5,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 11.0001,
  width: 5,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1 15.185C1 15.0828 1.08279 15.0001 1.18491 15.0001H8.8047C8.84998 15.0001 8.8937 15.0167 8.92754 15.0468L9.6365 15.6769C9.76358 15.7899 9.68368 16.0001 9.51365 16.0001H1.18491C1.08279 16.0001 1 15.9173 1 15.8152V15.185Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5872 16.7103L17.6962 18.6311M18.3001 15.7213L19.4092 17.6422",
  stroke: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0503 19.3624C17.0063 19.2862 17.027 19.189 17.0983 19.1374L18.5142 18.1116C18.5237 18.1047 18.534 18.0987 18.5449 18.0939L20.1411 17.3806C20.2215 17.3447 20.316 17.3753 20.36 17.4515L22.3852 20.9593C22.4292 21.0356 22.4085 21.1327 22.3372 21.1844L20.9213 22.2101C20.9118 22.2171 20.9015 22.223 20.8906 22.2278L19.2944 22.9412C19.214 22.9771 19.1195 22.9464 19.0755 22.8702L17.0503 19.3624Z",
  stroke: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3306 1.096C13.4357 1.03645 13.5643 1.03645 13.6694 1.096L20.8258 5.15127C20.9335 5.21229 21 5.32649 21 5.45025V13.5497C21 13.6735 20.9335 13.7877 20.8258 13.8487L13.6694 17.904C13.5643 17.9635 13.4357 17.9635 13.3306 17.904L6.17422 13.8487C6.06655 13.7877 6 13.6735 6 13.5497V5.45025C6 5.32649 6.06655 5.21229 6.17422 5.15127L13.3306 1.096Z",
  stroke: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 7.00006,
  width: 7,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 11.0001,
  width: 7,
  height: 1,
  rx: 0.171821,
  fill: "white"
});

var SvgCodeIssues = function SvgCodeIssues(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCodeIssues, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/code-issues.3474c73b.svg";
export { ForwardRef as ReactComponent };